export default function initToggle() {
    const toggleTriggerElems = document.querySelectorAll('[data-toggle]');
    toggleTriggerElems.forEach((elem) => {
        const targetElem = document.querySelector(`[id="${elem.getAttribute('data-toggle')}"]`);
        elem.addEventListener('click', () => {
            elem.toggleAttribute('aria-expanded');
            targetElem.toggleAttribute('aria-hidden');
            $("body").toggleClass("overflow-hidden");
        });
    });
}